import { AbstractControl, FormGroupDirective, NgForm } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

export class CustomFormControlErrorStateMatcher implements ErrorStateMatcher {
    private readonly formErrorsNames: string[];

    constructor(formErrorCodesRelevantToFormControl?: string[]) {
        this.formErrorsNames = [];
        if (formErrorCodesRelevantToFormControl != null) {
            this.formErrorsNames.push(...formErrorCodesRelevantToFormControl);
        }
    }

    isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null): boolean {
        if (control == null) {
            return false;
        }

        const isControlInvalid = control.invalid;
        const isControlTouched = control.touched;

        const isFormHasErrors = form != null && form.errors != null;

        if (!isFormHasErrors) {
            return isControlInvalid && isControlTouched;
        }
        if (this.formErrorsNames == null || this.formErrorsNames.length === 0) {
            return (isControlInvalid && isControlTouched) || isFormHasErrors;
        }

        let isFormErrorsRelevantToControlExist = false;
        for (const formErrorName of this.formErrorsNames) {
            if (form.hasError(formErrorName)) {
                isFormErrorsRelevantToControlExist = true;
                break;
            }
        }

        return (isControlInvalid && isControlTouched) || isFormErrorsRelevantToControlExist;
    }
}
